import { render, staticRenderFns } from "./ForumsThread.vue?vue&type=template&id=73ffaabc&"
import script from "./ForumsThread.vue?vue&type=script&lang=js&"
export * from "./ForumsThread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports